import { render, staticRenderFns } from "./ManageLogsPage.vue?vue&type=template&id=5ab7ed03&scoped=true"
import script from "./ManageLogsPage.vue?vue&type=script&lang=ts"
export * from "./ManageLogsPage.vue?vue&type=script&lang=ts"
import style0 from "./ManageLogsPage.vue?vue&type=style&index=0&id=5ab7ed03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7ed03",
  null
  
)

export default component.exports